export const GET_MAKE_REQUEST = "GET_MAKE_REQUEST"
export const GET_MAKE_SUCCESS = "GET_MAKE_SUCCESS"
export const GET_MAKE_FAIL = "GET_MAKE_FAIL"

export const GET_MODEL_REQUEST = "GET_MODEL_REQUEST"
export const GET_MODEL_SUCCESS = "GET_MODEL_SUCCESS"
export const GET_MODEL_FAIL = "GET_MODEL_FAIL"

export const GET_INSURANCECOMPANY_REQUEST = "GET_INSURANCECOMPANY_REQUEST"
export const GET_INSURANCECOMPANY_SUCCESS = "GET_INSURANCECOMPANY_SUCCESS"
export const GET_INSURANCECOMPANY_FAIL = "GET_INSURANCECOMPANY_FAIL"

export const GET_PRODUCTLIST_REQUEST = "GET_PRODUCTLIST_REQUEST"
export const GET_PRODUCTLIST_SUCCESS = "GET_PRODUCTLIST_SUCCESS"
export const GET_PRODUCTLIST_FAIL = "GET_PRODUCTLIST_FAIL"

export const GET_VEHICLE_REQUEST = "GET_VEHICLE_REQUEST"
export const GET_VEHICLE_SUCCESS = "GET_VEHICLE_SUCCESS"
export const GET_VEHICLE_FAIL = "GET_VEHICLE_FAIL"


